import React from 'react';
import PropTypes from 'prop-types';
import ReactSplitPane from 'react-split-pane';
import Theme from "./Theme.js"; // import './SplitPane.css'
/** 
 * React class that renders a SplitPane 
 * @see {@link https://github.com/tomkp/react-split-pane} is the base widget this uses 
 * @property {string} className - css class to be applied to this component 
 * @property {string} variant - Theme variant name to be added to the component 
 * @property {'vertical' | 'horizontal'} split 
 * @property {number} minSize - sets the minimum size of the primary pane 
 * @property {number} maxSize - sets the maximum size of the primary pane 
 * @property {number} defaultSize - sets the default size of the primary pane 
 * @property {function} onChange - function to be called with the onChange method 
 * @property {function} autoSaveKey - key which saves the last value to local storage 
 * @property {any} eventData - will be passed through as the data key to the onClick function
 */
import { jsx as _jsx } from "react/jsx-runtime";
class SplitPane extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    split: PropTypes.oneOf(['vertical', 'horizontal']),
    minSize: PropTypes.number,
    maxSize: PropTypes.number,
    defaultSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    autoSaveKey: PropTypes.string,
    eventData: PropTypes.any
  };
  static defaultProps = {
    className: null,
    variant: null,
    split: 'vertical',
    eventData: null,
    minSize: null,
    maxSize: null,
    defaultSize: null,
    onChange: null,
    autoSaveKey: null
  };

  /**
   * (Internal) gets called by the widget's onChange. sets the last pane size to local storage and calls the onChange prop with eventData
   */
  onChange = size => {
    const {
      autoSaveKey,
      split,
      eventData,
      onChange
    } = this.props;
    if (onChange) {
      onChange({
        data: eventData,
        size
      });
    }
    if (autoSaveKey && typeof localStorage !== 'undefined') {
      const sz = split === 'vertical' ? window.innerWidth : window.innerHeight;
      localStorage.setItem(`${autoSaveKey}.size`, size);
      localStorage.setItem(`${autoSaveKey}.fraction`, sz ? size / sz : 0);
      if (window && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new Event('resize'));
      }
    }
  };
  render() {
    const theme = this.context;
    const {
      className,
      autoSaveKey,
      variant,
      onChange,
      eventData,
      layoutOptions,
      ...rest
    } = this.props; // eslint-disable-line
    const cn = theme.classes('SplitPane', 'splitPane', variant, className);
    if (autoSaveKey) {
      const sz = rest.split === 'vertical' ? window.innerWidth : window.innerHeight;
      let saved = localStorage.getItem(`${autoSaveKey}.size`);
      let fraction = localStorage.getItem(`${autoSaveKey}.fraction`);
      if (saved != null && fraction != null) {
        fraction = parseFloat(fraction);
        saved = parseInt(saved);
        if (saved > sz * fraction) {
          saved = sz * fraction;
        }
        rest.defaultSize = saved;
      }
    }
    return /*#__PURE__*/_jsx(ReactSplitPane, {
      onChange: this.onChange,
      className: cn,
      ...rest
    });
  }
}
export default SplitPane;